<template>
  <div class="demo">
    <div class="hero">
      <div class="container">
        <h3>Blogpost</h3>
        <h1>Wat als de schaakcomputer de behandeling gaat inplannen?</h1>
        <p>
          In 1985 werd de eerste schaakcomputer ontwikkeld. Tegenwoordig is het
          zo vanzelfsprekend dat een schaakcomputer beter kan schaken dan een
          goede schaakspeler. Het is zelfs niet meer dan logisch dat een
          schaakcomputer met 5, 10 of 100 mensen tegelijk kan schaken. Bovendien
          kan hij tientallen stappen vooruitdenken en meerdere strategieën
          uitproberen om zo van iedereen te kunnen winnen. Ook weten we allemaal
          dat een normaal mens alleen van de schaakcomputer kan winnen als de
          computer bewust fouten maakt …. En toch laten organisaties hun zeer
          complexe planningspuzzel oplossen door een planner. Dat is zoooo 1985!
        </p>
        <div class="image">
          <img
            src="../assets/img/blog-images/schaakcomputer.png"
            alt=""
          >
        </div>
      </div>
    </div>

    <div class="section grey-light extra-padding-bottom">
      <div class="container">
        <div class="section-title">
          <h3>Superplanner gezocht!</h3>
        </div>
        <p>
          We gaan op zoek naar een superplanner. Een soort super(wo)man, met
          bovennatuurlijke talenten. Want dat heb je wel nodig om een
          fantastische planning op te leveren. Er moet rekening worden gehouden
          met alle verschillende wensen en eisen van de revalidant, de
          behandelaar en de organisatie. Ook moet de superplanner overzicht
          houden en inzicht hebben in alle beslissingen die er genomen moeten
          worden tijdens het planproces van alle cliënten in de hele
          organisatie.
        </p>

        <div class="section-title">
          <h3>Roosterplatform als superplanner?</h3>
        </div>
        <p>
          Is het echt goed plannen van alle multidisciplinaire
          behandelprogramma’s eigenlijk wel mogelijk voor de planner of de
          behandelaar? Een mens is nu eenmaal niet in staat om in een rap tempo
          alles te overzien en in datzelfde tempo altijd de juiste beslissingen
          te nemen. Om van begin tot eind weloverwogen keuzes te maken, te
          onderbouwen, te onthouden, te verantwoorden en congruent toe te
          passen, heeft de planner ondersteuning nodig.
        </p>
        <p>
          Ik denk dat je als behandelaar of organisatie wilt dat een cliënt het
          voorgeschreven behandelprogramma daadwerkelijk krijgt. En als je dat
          wilt combineren met de wensen, eisen, beschikbaarheid van de cliënt en
          de behandelaar op basis van de door de organisatie bepaalde kaders,
          blijft er maar 1 optie over: We zoeken een planner die net zo snel is
          als een schaakcomputer!
        </p>

        <div class="section-title">
          <h3>Plannen lijkt op snelschaken.</h3>
        </div>
        <p>
          Roosterplatform is specifiek gemaakt om automatisch te plannen net
          zoals een schaakcomputer specifiek gemaakt is voor een potje schaken.
          Een belangrijk aspect is dat plannen erg op snelschaken lijkt. Je hebt
          maar een paar minuten om je volgende set te bepalen. Immers als
          planners heb je in de GRZ zomaar 1.500 activiteiten en in de MSR
          zomaar 10.000 activiteiten per week te plannen. En deze planning moet
          bijvoorbeeld op de vrijdag gemaakt worden. Dat betekent dat er altijd
          tijdsdruk is. Roosterplatform is exact hiervoor gemaakt.
        </p>
        <p>
          Een belangrijke overeenkomst tussen de schaakcomputer en
          Roosterplatform is dat ze allebei gemakkelijk 100 sets vooruit kunnen
          denken. Daarnaast kunnen beiden diverse strategieën toepassen en heel
          veel spelletjes tegelijk spelen. Voor de schaakcomputer én
          Roosterplatform is het geen probleem om na elke set opnieuw alle
          mogelijke sets als reactie op het spel van de tegenstander (lees alle
          mutaties) door te rekenen.
        </p>
        <p>
          Roosterplatform plant vol automatisch. Oftewel, Roosterplatform rekent
          alles door, denkt 100 sets vooruit, gaat opnieuw rekenen en heeft in
          enkele minuten alle behandelingen gepland. Hierbij rekening houdend
          met alle protocollen, planningsstrategieën, wensen en eisen van
          cliënten en behandelaren binnen de kaders van de organisatie.
          Roosterplatform is zelfs in staat de beschikbaarheid van middelen en
          ruimtes en de reistijd tussen locaties te plannen.
        </p>
        <div class="section-title">
          <h3>En de planner dan?</h3>
        </div>
        <p>
          Betekent dit dan dat we helemaal geen planners meer nodig hebben? Nee
          dat zeker niet. De planner is hard nodig om de juiste wensen en eisen
          in het systeem in te vullen. En daarmee de balans te bewaken tussen
          revalidant, organisatie en behandelaar. Elke week is er weer nieuwe
          feedback op de planning. En daarmee een taak voor de planner om dit te
          integreren in de planningsstrategie voor de volgende week. Dit
          betekent dat hij in gesprek moet met behandelaar en management over
          wat wel en niet gewenst of toegestaan is. En op basis van deze
          strategie gaat roosterplatform de planning maken.
        </p>

        <div class="section-title">
          <h3>Schaakmat?</h3>
        </div>
        <p>
          Een optimale samenwerking van Roosterplatform en planner geeft een
          optimale planning. Een planning waarop je kan vertrouwen, bouwen en
          sturen. Elke week dezelfde kwaliteit! Want Roosterplatform staat elke
          dag 100% fit klaar om de puzzel optimaal te leggen. Roosterplatform
          wint het qua puzzelen simpelweg van de planner. En dat is logisch!
        </p>
        <span>Door: </span>
        <b>Herman de Jager - CEO Roosterplatform</b>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Article6",

  mounted() {},
  metaInfo() {
    return {
      title:
        "Roosterplatform - Wat als de schaakcomputer de behandeling gaat inplannen",
    };
  },
};
</script>

<style scoped lang="scss">
@import "../assets/css/colors.scss";
@import "../assets/css/variables.scss";
.hero {
  padding: 100px 0;
  p {
    font-size: $big;
  }
  h3 {
    opacity: 0.3;
    font-weight: 700;
  }
  position: relative;
  z-index: 1;
}
.zoho-form {
  background: $grey-light;
  border-radius: $border-radius;
}
img {
  border-radius: $border-radius;
}
p + .section-title {
  margin-top: 50px;
}
@media (max-width: 767px) {
  .hero {
    padding-top: $header-height-small;
  }
}
</style>
